import { Font } from '@react-pdf/renderer';

export const registerFonts = () => {
  Font.register({
    family: 'Inter',
    fonts: [
      {
        src: '/fonts/inter-latin-400-normal.woff',
        fontWeight: 400,
      },
      {
        src: '/fonts/inter-latin-700-normal.woff',
        fontWeight: 700,
      },
    ],
  });
};
